<mat-form-field
  style="width: 100%"
  floatLabel="always"
  [subscriptSizing]="subscriptSizing"
>
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="value"
    [multiple]="multiple"
    [disabled]="disabled"
    (selectionChange)="onSelectionChange($event.value)"
    [placeholder]="placeholder"
    data-testid="select-location"
  >
    <mat-option *ngIf="!multiple" [value]="null">-- None --</mat-option>
    <mat-option
      *ngFor="let location of locations$ | async"
      [value]="location.location_uuid"
    >
      {{ location.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
